import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, MessageSquare, LayoutDashboard } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const showPricing = ["/", "/pricing", "/tenant-pricing"].includes(location.pathname);

  const dash = user?.role === "tenant" ? "/tenant" : user?.role === "landlord" ? "/landlord" : "/admin";

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-border">
      <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/brand-logo.png" alt="MyRentalMatch" className="h-9 w-auto" />
        </Link>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button variant="ghost" size="sm" data-testid="nav-dashboard" onClick={() => navigate(dash)}>
                <LayoutDashboard className="w-4 h-4 mr-1.5" /> Dashboard
              </Button>
              {user.role !== "admin" && (
                <Button variant="ghost" size="sm" data-testid="nav-messages" onClick={() => navigate("/messages")}>
                  <MessageSquare className="w-4 h-4 mr-1.5" /> Messages
                </Button>
              )}
              <span className="text-sm text-muted-foreground hidden sm:inline">{user.name}</span>
              <Button variant="outline" size="sm" data-testid="nav-logout" onClick={() => { logout(); navigate("/"); }}>
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              {showPricing && (
                <>
                  <Button variant="ghost" size="sm" onClick={() => navigate("/tenant-pricing")} data-testid="nav-tenant-pricing">Tenant Pricing</Button>
                  <Button variant="ghost" size="sm" onClick={() => navigate("/pricing")} data-testid="nav-landlord-pricing">Landlord Pricing</Button>
                </>
              )}
              <Button size="sm" data-testid="nav-getstarted" onClick={() => navigate("/auth")}>Get Started</Button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};
